import dat from 'dat.gui'

export const gui = new dat.GUI()
gui.close()

export let guiObj = {
  focusDistance: 0.18,
  focalLength: 0.1,
  bokehScale: 3.6
}